// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyNotificaton_root__2_moN","closeButton":"StickyNotificaton_closeButton__3tcLI"};